import { useTranslation } from 'react-i18next';
import { Avatar, AvatarProps, Tooltip } from '@mantine/core';
import { useUser } from '@/queries/users/useUser';
import { localizeDisplayName } from '@/utils/displayName';
import { getUserImageUrl } from '@/utils/file';

export const UserBadge = ({
  userId,
  size = 20,
  withTooltip = true,
  style,
  displayName: displayNameOverride,
  image: imageOverride,
}: {
  userId: string;
  size?: AvatarProps['size'];
  withTooltip?: boolean;
  style?: React.CSSProperties;
  /** Pre-resolved badge props (e.g. embedded in an API response) — skip the store lookup when provided. */
  displayName?: string | null;
  image?: string | null;
}) => {
  const { t } = useTranslation();
  const hasOverride = displayNameOverride !== undefined;
  const { data: queriedUser } = useUser(hasOverride ? undefined : userId);

  if (!hasOverride && !queriedUser) {
    return null;
  }

  const displayName = localizeDisplayName(
    hasOverride ? displayNameOverride : queriedUser?.displayName,
    t
  );
  const image = hasOverride ? imageOverride : queriedUser?.image;

  if (image) {
    return (
      <Tooltip label={displayName} disabled={!withTooltip || !displayName}>
        <Avatar
          src={getUserImageUrl(userId)}
          size={size}
          name={displayName ?? undefined}
          color="initials"
          style={style}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip label={displayName} disabled={!withTooltip || !displayName}>
      <Avatar size={size} name={displayName ?? undefined} color="initials" style={style} />
    </Tooltip>
  );
};
